import React from 'react';

const DecorativeShapes: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div aria-hidden className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
    <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-blue-500 opacity-5" />
    <div className="absolute -bottom-24 -right-24 w-80 h-80 rounded-full bg-emerald-500 opacity-5" />
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 rounded-full bg-amber-400 opacity-[0.03]" />
  </div>
);

export { DecorativeShapes };
